import * as React from 'react';

import { useQuery } from '@apollo/client';

import { useSkillPathway } from 'bundles/enterprise-learning-path-description-page/contexts/SkillPathwayContext';
import SkillPathwayPartnersContext from 'bundles/enterprise-learning-path-description-page/contexts/SkillPathwayPartnersContext';
import GetPartnersByIds from 'bundles/enterprise-learning-path-description-page/queries/GetPartnersByIds.graphql';
import type {
  SkillPathwayGetPartnersByIdsQuery,
  SkillPathwayGetPartnersByIdsQueryVariables,
} from 'bundles/enterprise-learning-path-description-page/queries/__generated__/GetPartnersByIds';

const pathwayIdToPartnerMap = {
  '2v4HPJQFQ1GDB_yyhAcSqQ': ['1734', '705', '463', '1504', '348'],
  s2d2cHxZTYioUnQjYfKRSA: [
    '8',
    '463',
    '1342',
    '1734',
    '705',
    '1504',
    '2597',
    '348',
    '1160',
    '287',
    '829',
    '1018',
    '475',
    '639',
    '459',
  ],
};

type SkillPathwayPartnersProviderProps = {
  children: React.ReactNode;
};

// For the pilot of verified skills, to get around a bug with course builder, we are fetching hardcoded partner IDs.
// Use these partners over the partners attached to learning pathways if this is populated.
const SkillPathwayPartnersProvider = ({ children }: SkillPathwayPartnersProviderProps) => {
  const skillPathway = useSkillPathway();
  const partnerIds = skillPathway?.id
    ? pathwayIdToPartnerMap[skillPathway?.id as keyof typeof pathwayIdToPartnerMap]
    : [];
  const { data } = useQuery<SkillPathwayGetPartnersByIdsQuery, SkillPathwayGetPartnersByIdsQueryVariables>(
    GetPartnersByIds,
    {
      variables: { ids: partnerIds },
      skip: partnerIds.length === 0,
      context: { clientName: 'gatewayGql' },
      fetchPolicy: 'cache-first',
    }
  );

  return (
    <SkillPathwayPartnersContext.Provider
      value={{
        partners: data?.Partner?.queryByIds,
      }}
    >
      {children}
    </SkillPathwayPartnersContext.Provider>
  );
};

export default SkillPathwayPartnersProvider;
